import React, { FC } from "react";
import { Spinner } from "react-bootstrap";
import Const from "../../const.json";

const Loader: FC = () => {
  return (
    <div>
      <div className="W-100 d-flex flex-column align-items-center custom-loader">
        <span>
          {Const.loading}
        </span>
        <Spinner animation="border" role="status"></Spinner>
      </div>
    </div>
  );
};

export default Loader;
